import React, { FC, ReactNode } from 'react';

import styled from 'styled-components';

import { Typography, TypographyProps } from '@mui/material';

import { themes } from '../../../../consts/experiences';
import { Spacing, margin, padding } from '../../helpers';

// TODO: Duplicate. Use TypographyProps instead. Replace usage.
type TextProps = TypographyProps & {
  size?: string;
  color?: string;
  align?: string;
  weight?: number;
  lineHeight?: string;
  children?: ReactNode;
} & Spacing;

export const Text = styled((props: TextProps) => <Typography component="p" {...props} />)`
  width: 100%;
  font-size: ${({ size }) => size || '16px'};
  text-align: ${({ align }) => align || 'left'};
  font-weight: ${({ weight }) => weight || 400};
  color: ${({ color }) => color || themes?.primaryDark};
  line-height: ${({ lineHeight }) => lineHeight || '19px'};

  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};
` as FC<TextProps>;
